import {defaults}     from "../../commun/backbone/decorators";
import Routing        from "../app/router";
import LoginBaseModel from "./login-base-model";

@defaults({
                with_configuration: false,
          })
class LoginModel extends LoginBaseModel
{
    fGetUserInfo(login)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                   url  : Routing.generate('session_user_info'),
                   data : { login }
               }).then(resolve, reject);
        });
    }

    resetPassword(login)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                   url  : Routing.generate('session_reset_password_intranet'),
                   data : { login }
               }).then(resolve, reject);
        });
    }

    executeAction(idaction)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                       url  : Routing.generate('session_execute_action', { idaction }),
                   }).then(resolve, reject);
        });
    }
}
export default LoginModel;